/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/Accordion.module.scss';
import ChequeStatusFaq from './ChequeStatusFaq';
import FaqFeedback from '../common/FaqFeedback';
import FaqTicketCreate from '../common/FaqTicketCreate';
import {
  clickTracker,
  DefaultErrMsg,
  getPaymentsSubEventType,
  getSourceValue,
  handleRedirection,
  helpfulObjData,
} from '../../lib/common';
import { handleShowTagsFeedback } from '../../reducersAndActions/actions/appStateActions';
import { useAppState } from '../../contexts/appState';
import { PostGenericApiCall, handleImpressionsTrack } from '../../api';
import { useAuth } from '../../contexts/auth';
import { server } from '../../config';
import DownloadInvoice from './DownloadInvoice';
import useAlert from '../../hooks/useAlert';
import PaymentLatest from './PaymentLatest';

const PaymentsFaq = (props) => {
  const { paymentsFaq, projectId, selectedBusinessData } = props;
  const { faqdetails, paymentChequeStatusObj, stopChequeFaqObj } = paymentsFaq;
  const [faqData, setFaqData] = useState(faqdetails || []);
  const [faqResponse] = useState(faqdetails || []);
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [setActive, setActiveState] = useState('');
  const [showAns, setShowAns] = useState(false);
  const [helpful, setHelpful] = useState(helpfulObjData && helpfulObjData);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [showData, setShowData] = useState(true);
  const [faqsFeedbackData, setFaqsFeedbackData] = useState({});
  const [selectedFaqData, setSelectedFaqData] = useState({});
  const [showTicketCreate, setShowTicketCreate] = useState(false);
  const [showMore, setShowMore] = useState(true);
  const [payInvo, setPayInvo] = useState({});
  const [genInvoClick, setGenInvoClick] = useState({ clicked: false, invoData: [], invoType: '' });
  const [setAlert] = useAlert();
  const source = getSourceValue();
  const [, appDispatch] = useAppState();
  const [authState] = useAuth();
  const [loading, setLoading] = useState(false);

  let searchQid = '';
  searchQid = localStorage.getItem('searchQid');

  const handlePaymentClick = async (e) => {
    if (document.getElementById('paymentInvoice')) {
      if (e.target.id === 'paymentInvoice' && selectedFaqData?.paramUrl) {
        await clickTracker(
          `FAQ_${getPaymentsSubEventType?.[selectedFaqData?.pop]}_redirection`,
          `payments_FAQ_${getPaymentsSubEventType?.[selectedFaqData?.pop]}`,
        );
        if (projectId === 'csportal') {
          const liVal = 'click';
          const liTrd = `cta_clickhere`;
          const faqTypeVal = '';
          const othersData = [];
          const llTrd = 'issue_payments';
          const llTrdInside = `faq_${selectedFaqData?.faqKey}`;
          await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
        }
        handleRedirection(source, selectedFaqData?.paramUrl || '');
      }
    } else if (document.getElementById('pmt') && e.target.id === 'pmt') {
      console.log();
    }
  };

  const paymentInvoiceInfo = async () => {
    setLoading(true);
    const url = `${server.apiURL}csportal/paymentInvoiceInfo`;
    if (selectedBusinessData && selectedBusinessData.parentid && selectedBusinessData.data_city) {
      const payInvData = {
        parentid: selectedBusinessData.parentid || '',
        city: selectedBusinessData.data_city || '',
      };
      const payRes = await PostGenericApiCall(url, payInvData);
      if (payRes?.errorCode === 0) {
        setPayInvo(payRes?.result || {});
      } else {
        setAlert({ message: payRes?.message || DefaultErrMsg, status: false });
      }
      setLoading(false);
    } else {
      setAlert({ message: 'Please reselect business', status: false });
    }
    setLoading(false);
  };

  const handleFaqClick = async (data, index) => {
    handleShowTagsFeedback(appDispatch, {});
    setShowData(true);
    setActiveIndex(index === activeIndex ? -1 : index);
    setHelpful(helpfulObjData && helpfulObjData);
    setSelectedFaqData(data);
    setSelectedQuestionId(selectedQuestionId === index ? null : index);
    setShowAns(selectedQuestionId !== index);
    setActiveState(setActive === '' || selectedQuestionId !== index ? `${styles.Active}` : ``);
    setShowTicketCreate(false);
    if (selectedQuestionId !== index) {
      if (data?.id === 126) {
        await paymentInvoiceInfo();
      }
      await clickTracker(
        `FAQ_${getPaymentsSubEventType?.[data?.pop]}`,
        projectId === 'csportal' ? 'payments_FAQ' : 'geniocs_payments_faq',
      );
      if (projectId === 'csportal') {
        const liVal = 'click';
        const liTrd = `faq_${data?.faqKey}`;
        const faqTypeVal = '';
        const othersData = [];
        const llTrd = 'issue_payments';
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
      }
    }
  };

  const handleSearchFaq = () => {
    if (searchQid && searchQid !== '') {
      const data = faqData;
      data?.forEach((ele, i) => {
        if (ele?.id?.toString() === searchQid) {
          data?.splice(i, 1);
          data?.unshift(ele);
        }
      });

      data?.forEach((faq, i) => {
        if (faq?.id?.toString() === searchQid) {
          handleFaqClick(faq, i);
        }
      });
      setFaqData(data);
    }
  };

  useEffect(() => {
    window.addEventListener('click', handlePaymentClick);
    return () => {
      window.removeEventListener('click', handlePaymentClick);
    };
  }, [selectedFaqData]);

  useEffect(() => {
    handleSearchFaq();
  }, []);

  const updatedFaqs = showMore ? (faqData && faqData.length > 0 ? faqData.slice(0, 4) : faqData) : faqData;
  // const updatedFaqs = faqData;

  const handlePaymentsRedirection = async (faqId) => {
    await clickTracker(
      `FAQ_${faqId === 2 ? 'invoiceedit' : 'invoicegst'}_redirection`,
      `payments_FAQ_${faqId === 2 ? 'invoiceedit' : 'invoicegst'}`,
    );
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `cta_${faqId === 2 ? 'editlisting' : 'editgstn'}`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `issue_payments`;
      const llTrdInside = `faq_${selectedFaqData?.faqKey}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
    }
    handleRedirection(source, selectedFaqData?.paramUrl || '');
  };

  const payInvoInfo = async (invoType) => {
    if (
      invoType === 'invoice'
        ? !payInvo?.invoicesArr || payInvo?.invoicesArr?.length === 0
        : !payInvo?.ecsInvoicesArr || payInvo?.ecsInvoicesArr?.length === 0
    ) {
      setAlert({
        message: invoType === 'invoice' ? 'Payment invoice data not found' : 'ECS Payment invoice data not found',
        status: false,
      });
      return;
    }
    document.body.style.overflow = 'hidden';
    setGenInvoClick({
      clicked: true,
      invoData:
        invoType === 'invoice'
          ? payInvo?.invoicesArr?.length > 0
            ? payInvo?.invoicesArr
            : []
          : payInvo?.ecsInvoicesArr?.length > 0
            ? payInvo?.ecsInvoicesArr
            : [],
      invoType,
    });
  };

  return (
    <>
      <div className="p-20">
        <div className={`${styles.Heading}`}>
          <div className={`${styles.Title} font16 fw700 color111`}>Payments & Invoices</div>
        </div>
        <div className={`${styles.Accordion__Box}`}>
          <div className="mt-10">
            {faqResponse && faqResponse.length > 0 ? (
              <>
                {updatedFaqs &&
                  updatedFaqs.map((each, idx) => (
                    <div key={idx}>
                      <div
                        aria-label="payments_faq_click"
                        tabIndex={0}
                        role="button"
                        onKeyDown={() => {}}
                        onClick={() => handleFaqClick(each, idx)}
                        className={`${styles.Accordion__Pannel__Heading} ${
                          selectedQuestionId === idx && showAns ? setActive : ''
                        }`}
                      >
                        <div className={`${styles.Accordion__Pannel__Title} font13 fw500 color111`}>
                          {each?.question || ''}
                        </div>
                        <div className={`${styles.Accordion__Pannel__Icon} csicon`} />
                      </div>

                      <div className={`${styles.Accordion__Contant}`}>
                        <div className={`${styles.Accordion__TextContant}`}>
                          {showData && each?.type !== 'create' ? (
                            each.id === 126 ? (
                              <>
                                {loading ? (
                                  <div style={{ height: '100px' }}>
                                    <div className="loader-div">
                                      <div className="bt-spinner" style={{ height: '25px', width: '25px' }} />
                                    </div>
                                  </div>
                                ) : (
                                  <>
                                    {payInvo?.invoiceObj && Object.keys(payInvo?.invoiceObj)?.length > 0 ? (
                                      <div className="FaqNegative">
                                        <PaymentLatest
                                          styles={styles}
                                          invoiceObj={payInvo?.invoiceObj || {}}
                                          payInvoInfo={payInvoInfo}
                                          handlePaymentClick={handlePaymentClick}
                                          showEcsInvoice={payInvo?.showEcsInvoice}
                                        />
                                        <FaqFeedback
                                          faq={each}
                                          helpful={helpful}
                                          setHelpful={setHelpful}
                                          setShowData={setShowData}
                                          faqsFeedbackData={faqsFeedbackData}
                                          setFaqsFeedbackData={setFaqsFeedbackData}
                                          id="payments"
                                        />
                                      </div>
                                    ) : (
                                      <div style={{ marginTop: 0 }} className="no-data-div font12">
                                        No payment invoices data
                                      </div>
                                    )}
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {each.type === 'API' ? (
                                  <ChequeStatusFaq
                                    data={paymentChequeStatusObj}
                                    showTicketCreate={showTicketCreate}
                                    setShowTicketCreate={setShowTicketCreate}
                                    faqObj={each}
                                    activeIndex={activeIndex}
                                    setShowData={setShowData}
                                    stopChequeFaqObj={stopChequeFaqObj}
                                  />
                                ) : (
                                  <>
                                    <div
                                      aria-label="payments_faq_redirection"
                                      tabIndex={0}
                                      role="button"
                                      onKeyDown={() => {}}
                                      onClick={handlePaymentClick}
                                      className="font12 fw400 color777 p-10"
                                      id="payments-faqs-ans"
                                      dangerouslySetInnerHTML={{ __html: each?.ans }}
                                    />
                                    {projectId === 'csportal' && [2, 3].includes(each?.pop) && (
                                      <div className="mr-10 ml-10 mt-5">
                                        <button
                                          onClick={() => handlePaymentsRedirection(each?.pop)}
                                          type="button"
                                          className={`${styles.submit__Btn} font13 fw500 colorFFF`}
                                        >
                                          {each?.pop === 2 ? 'Edit Listing' : 'Edit my GSTN'}
                                        </button>
                                      </div>
                                    )}
                                  </>
                                )}
                                {((each?.type !== 'create' && each?.type !== 'API') ||
                                  (each.pop === 7 && paymentChequeStatusObj?.showFeedback && !showTicketCreate) ||
                                  (each.pop === 8 && stopChequeFaqObj?.chequeCleared)) && (
                                  <FaqFeedback
                                    faq={each}
                                    helpful={helpful}
                                    setHelpful={setHelpful}
                                    setShowData={setShowData}
                                    faqsFeedbackData={faqsFeedbackData}
                                    setFaqsFeedbackData={setFaqsFeedbackData}
                                    id="payments"
                                  />
                                )}
                              </>
                            )
                          ) : (
                            <>
                              {((helpful && helpful[1].isActive) || each?.type === 'create') && (
                                <div className={each?.type === 'create' || projectId === 'genio' ? 'p-10' : ''}>
                                  <FaqTicketCreate
                                    issue={each?.issue || ''}
                                    subIssue={each?.subIssue || ''}
                                    activeIndex={activeIndex}
                                    vertical="Listing"
                                    category="CS"
                                    ticketCreator="BUSINESS"
                                    setShowData={setShowData}
                                    hideAlert
                                    hideCrossIcon={each?.type === 'create'}
                                    id="payments"
                                    faqId={each?.pop}
                                    projectId={projectId}
                                    faqObj={each}
                                  />
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
              </>
            ) : (
              <div className="no-data-div">No Data</div>
            )}
            <div className="text_center pt-10 pl-20 pr-20">
              <button
                type="button"
                className={`${styles.viewMore__Btn}`}
                onClick={async () => {
                  setShowMore((prev) => !prev);
                  if (searchQid && searchQid === '') {
                    setSelectedQuestionId(null);
                  }
                  await clickTracker(
                    showMore ? 'viewmore' : 'viewless',
                    projectId === 'csportal' ? 'payments_FAQ' : 'geniocs_payments_faq',
                  );
                }}
              >
                {showMore ? 'View More' : 'View Less'}
              </button>
            </div>
          </div>
          {genInvoClick.clicked && (
            <DownloadInvoice
              invoData={genInvoClick?.invoData || []}
              selectedBusinessData={selectedBusinessData}
              setGenInvoClick={setGenInvoClick}
              setAlert={setAlert}
              genInvoClick={genInvoClick}
            />
          )}
        </div>
      </div>
    </>
  );
};

PaymentsFaq.propTypes = {
  paymentsFaq: PropTypes.object,
  projectId: PropTypes.string,
  selectedBusinessData: PropTypes.any,
};

export default PaymentsFaq;
